// "Cookie settings" link in the footer: reopens the consent bar with the
// per-category settings (replaces volto-gdpr-privacy's floating side icon).
import React from 'react';
import { useDispatch } from 'react-redux';
import { displayBanner } from 'volto-gdpr-privacy/actions';

const CookieSettingsLink = () => {
  const dispatch = useDispatch();
  return (
    <button
      type="button"
      className="arkus-cookie-settings"
      onClick={() => dispatch(displayBanner(true, true))}
    >
      Cookie settings
    </button>
  );
};

export default CookieSettingsLink;
